// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./AlexBrush-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Caveat-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Cinzel-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./DancingScript-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./GreatVibes-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Montserrat-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Pacifico-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./PlayfairDisplay-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Tangerine-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Alex Brush';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
@font-face {
  font-family: 'Caveat';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
  font-family: 'Cinzel';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
  font-family: 'Dancing Script';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
  font-family: 'Great Vibes';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
  font-family: 'Montserrat';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
@font-face {
  font-family: 'Pacifico';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}
@font-face {
  font-family: 'Playfair Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}
@font-face {
  font-family: 'Tangerine';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}`, "",{"version":3,"sources":["webpack://./src/fonts/fonts.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+DAAsD;AACxD;AACA;EACE,qBAAqB;EACrB,+DAA6D;AAC/D;AACA;EACE,qBAAqB;EACrB,+DAA6D;AAC/D;AACA;EACE,6BAA6B;EAC7B,+DAAoE;AACtE;AACA;EACE,0BAA0B;EAC1B,+DAAuD;AACzD;AACA;EACE,yBAAyB;EACzB,+DAAiE;AACnE;AACA;EACE,uBAAuB;EACvB,+DAAqD;AACvD;AACA;EACE,+BAA+B;EAC/B,+DAAsE;AACxE;AACA;EACE,wBAAwB;EACxB,+DAAsD;AACxD","sourcesContent":["@font-face {\n  font-family: 'Alex Brush';\n  src: url('./AlexBrush-Regular.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Caveat';\n  src: url('./Caveat-VariableFont_wght.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Cinzel';\n  src: url('./Cinzel-VariableFont_wght.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Dancing Script';\n  src: url('./DancingScript-VariableFont_wght.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Great Vibes';\n  src: url('./GreatVibes-Regular.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Montserrat';\n  src: url('./Montserrat-VariableFont_wght.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Pacifico';\n  src: url('./Pacifico-Regular.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Playfair Display';\n  src: url('./PlayfairDisplay-VariableFont_wght.ttf') format('truetype');\n}\n@font-face {\n  font-family: 'Tangerine';\n  src: url('./Tangerine-Regular.ttf') format('truetype');\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
